var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 16.625L6 12.875",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.94387 15.0286C7.13637 14.3911 4.48383 11.7386 3.8464 8.93113C3.74549 8.48668 3.69504 8.2645 3.84121 7.90398C3.98737 7.54347 4.16593 7.43191 4.52303 7.20882C5.33029 6.70449 6.2044 6.54416 7.11157 6.6244C8.38447 6.73699 9.02092 6.79328 9.3384 6.62786C9.65595 6.46243 9.87165 6.07563 10.3032 5.30202L10.8498 4.32203C11.2099 3.67646 11.3899 3.35368 11.8135 3.20152C12.237 3.04935 12.4918 3.14149 13.0016 3.32578C14.1937 3.75677 15.1182 4.68129 15.5492 5.87337C15.7335 6.38313 15.8257 6.63801 15.6735 7.06153C15.5213 7.48505 15.1985 7.6651 14.5529 8.02519L13.5504 8.5844C12.7782 9.01505 12.3922 9.23045 12.2268 9.551C12.0614 9.87163 12.1215 10.4942 12.2416 11.7394C12.3299 12.6551 12.1777 13.535 11.6666 14.3523C11.4433 14.7094 11.3316 14.8879 10.9712 15.034C10.6108 15.18 10.3885 15.1295 9.94387 15.0286Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.2a0f22d2f1b0213db117939ca7a3e680.svg";
export { ForwardRef as ReactComponent };